import { Environment } from 'environment.js'
import { useSelector } from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import type { State } from 'Flux/Slice/index.js'
import { createSelector } from '@reduxjs/toolkit'
import type { ISampleMetaData } from 'Model/Sample/ISampleMetaData.js'
import { sampleMetaDataStub } from 'Model/Sample/SampleMetaDataStub.js'

export const useGetSampleMetaDataSelector: () => ISampleMetaData[] = () => {
  return useSelector(getSampleMetaDatas)
}
const testSampleMetaDatas: ISampleMetaData[] = sampleMetaDataStub

const selectMetaDatas = (state: typeof State) =>
  Environment.DEV_SKIP_LOGIN === 'true' && Environment.ENVIRONMENT === 'development'
    ? testSampleMetaDatas
    : state[orderSlice.name].sampleMetaDatas

export const getSampleMetaDatas = createSelector(selectMetaDatas, (metaDatas) => Object.values(metaDatas))
